module.exports = __webpack_public_path__ + "static/media/wp-debug.b56fb684.svg";